"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OLHoverProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const useOLMap_1 = require("../openlayers/useOLMap");
function OLHoverProvider({ children }) {
    const map = useOLMap_1.useOLMap();
    const previouslyHovered = react_1.useRef(null);
    react_1.useEffect(() => {
        const pointerMove = (e) => {
            var _a, _b, _c;
            const hoveredNow = (_b = (_a = e.map.getFeaturesAtPixel(e.pixel)) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : null;
            if (!hoveredNow) {
                if (previouslyHovered.current) {
                    previouslyHovered.current.dispatchEvent('mouseout');
                    previouslyHovered.current = null;
                }
            }
            else {
                if (previouslyHovered.current) {
                    if (hoveredNow.getId() === ((_c = previouslyHovered.current) === null || _c === void 0 ? void 0 : _c.getId())) {
                        return;
                    }
                    else {
                        previouslyHovered.current.dispatchEvent('mouseout');
                        previouslyHovered.current = null;
                        if ('dispatchEvent' in hoveredNow) {
                            hoveredNow.dispatchEvent('mouseover');
                            previouslyHovered.current = hoveredNow;
                        }
                    }
                }
                else {
                    if ('dispatchEvent' in hoveredNow) {
                        hoveredNow.dispatchEvent('mouseover');
                        previouslyHovered.current = hoveredNow;
                    }
                }
            }
        };
        map.on('pointermove', pointerMove);
        return () => {
            map.un('pointermove', pointerMove);
        };
    }, [map]);
    return jsx_runtime_1.jsx(jsx_runtime_1.Fragment, { children: children }, void 0);
}
exports.OLHoverProvider = OLHoverProvider;
//# sourceMappingURL=OLHoverProvider.js.map